import { useEffect, useState } from "react";
import "./App.css";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import { Link, Route, BrowserRouter as Router, Routes } from "react-router-dom";
import EMICalculator from "./components/EmiCalculator.jsx/EmiCalculator";
import CarSelection from "./components/CarSelection/CarSelection";
import PPF from "./components/OurServices/ppf/PPF";
import Home from "./components/Home";
import Ceramic from "./components/OurServices/ppf/Ceramic";
import Graphene from "./components/OurServices/ppf/Graphene";
import ContactUs from "./components/OurServices/ppf/ContactUs";
import NotFound from "./NotFound";
import { ToastContainer } from "react-toastify";
import BuyersForm from "./components/CarSelection/dataCollection/BuyersForm";
import {
  FaArrowDown,
  FaArrowUp,
  FaFacebook,
  FaInstagram,
  FaTwitter,
} from "react-icons/fa";

function App() {
  const [showBuyCar, setShowBuyCar] = useState(false);
  const [showCalculator, setShowCalculator] = useState(false);
  const [showCarSelection, setShowCarSelection] = useState(false);
  const [transactionType, setTransactionType] = useState("");
  const [footerVisible, setFooterVisible] = useState(true);
  const [showScrollTop, setShowScrollTop] = useState(false);
  

  useEffect(() => {
    const checkFooterVisibility = () => {
      const footer = document.getElementById("footer");
      const footerRect = footer.getBoundingClientRect();
      const isFooterVisible = footerRect.top <= window.innerHeight;
      setFooterVisible(isFooterVisible);
    };

    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const halfPage = document.body.scrollHeight / 2;
      setShowScrollTop(scrollTop > halfPage);
    };

    checkFooterVisibility();
    window.addEventListener("scroll", checkFooterVisibility);
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", checkFooterVisibility);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleOpenCalculator = () => {
    setShowCalculator(true);
  };

  const handleCloseCalculator = () => {
    setShowCalculator(false);
  };

  const handleOpenCarSelection = (type) => {
    setTransactionType(type);
    setShowCarSelection(true);
  };

  const handleCloseCarSelection = () => {
    setTransactionType("");
    setShowCarSelection(false);
  };

  const handleOpenBuyCar = (type) => {
    setTransactionType(type);
    setShowCarSelection(true);
  };

  const handleCloseBuyCar = () => {
    setTransactionType("");
    setShowCarSelection(false);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const scrollToBottom = () => {
    const targetPosition = document.body.scrollHeight - 200;
    window.scrollTo({ top: targetPosition, behavior: "smooth" });
  };

  return (
    <Router>
      <div className="bg-gray-200">
        <div className="fixed p-2 rounded-lg left-0 top-24 md:top-1/2 transform -translate-y-1/7 flex flex-col gap-4 hidden md:flex z-50">
          <a
            href="https://www.facebook.com/profile.php?id=61570011824071/"
            target="_blank"
          >
            <FaFacebook
              size={40}
              className="text-blue-900 hover:text-blue-600"
            />
          </a>
          <a
            href="https://www.instagram.com/v_exotic_cars_v_ceramic_studio/"
            target="_blank"
          >
            <FaInstagram
              size={40}
              className="text-pink-900 hover:text-pink-500"
            />
          </a>
          <a href="https://x.com/VExoticCars/" target="_blank">
            <FaTwitter
              size={40}
              className="text-blue-900 hover:text-blue-500"
            />
          </a>
        </div>
        {!footerVisible && (
          <div
            className="fixed bottom-5 left-1/3 transform -translate-x-1/4 flex gap-5 z-50 transition-opacity md:left-1/2 md:-translate-x-1/2"
            style={{ fontFamily: "Barlow Condensed" }}
          >
            <button
              className="text-white bg-sky-600 px-2 py-1 sm:px-5 sm:py-2 rounded shadow-[-4px_4px_10px_0px_#5BCAFD_inset,_4px_-4px_4px_0px_rgba(0,_0,_0,_0.25)_inset,_0px_2px_4px_0px_#000]"
              onClick={() => handleOpenBuyCar("buy")}
            >
              Buy
            </button>
            <button
              className="text-white bg-sky-600 px-2 py-1 sm:px-5 sm:py-2 rounded shadow-[-4px_4px_10px_0px_#5BCAFD_inset,_4px_-4px_4px_0px_rgba(0,_0,_0,_0.25)_inset,_0px_2px_4px_0px_#000]"
              onClick={() => handleOpenCarSelection("sell")}
            >
              Sell
            </button>
            <button
              className="text-white bg-sky-600 px-2 py-1 sm:px-5 sm:py-2 rounded shadow-[-4px_4px_10px_0px_#5BCAFD_inset,_4px_-4px_4px_0px_rgba(0,_0,_0,_0.25)_inset,_0px_2px_4px_0px_#000]"
              onClick={handleOpenCalculator}
            >
              EMI Calculator
            </button>
          </div>
        )}

        {!footerVisible && (
          <Link
            to="/contact"
            className="fixed bottom-16 right-4 md:right-14 text-white bg-sky-600 p-2 sm:p-2 rounded shadow-[-4px_4px_10px_0px_#5BCAFD_inset,_4px_-4px_4px_0px_rgba(0,_0,_0,_0.25)_inset,_0px_2px_4px_0px_#000] z-50 w-12 h-12 sm:w-16 sm:h-16 transition-all duration-500 hover:bg-sky-500"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-full h-full"
              viewBox="0 0 32 32"
              fill="none"
            >
              <path
                d="M26.6 28C23.8222 28 21.0778 27.3947 18.3667 26.184C15.6556 24.9733 13.1889 23.2564 10.9667 21.0333C8.74445 18.8102 7.028 16.3436 5.81733 13.6333C4.60667 10.9231 4.00089 8.17867 4 5.4C4 5 4.13333 4.66667 4.4 4.4C4.66667 4.13333 5 4 5.4 4H10.8C11.1111 4 11.3889 4.10578 11.6333 4.31733C11.8778 4.52889 12.0222 4.77867 12.0667 5.06667L12.9333 9.73333C12.9778 10.0889 12.9667 10.3889 12.9 10.6333C12.8333 10.8778 12.7111 11.0889 12.5333 11.2667L9.3 14.5333C9.74444 15.3556 10.272 16.1498 10.8827 16.916C11.4933 17.6822 12.1658 18.4213 12.9 19.1333C13.5889 19.8222 14.3111 20.4613 15.0667 21.0507C15.8222 21.64 16.6222 22.1787 17.4667 22.6667L20.6 19.5333C20.8 19.3333 21.0613 19.1836 21.384 19.084C21.7067 18.9844 22.0231 18.9564 22.3333 19L26.9333 19.9333C27.2444 20.0222 27.5 20.1836 27.7 20.4173C27.9 20.6511 28 20.912 28 21.2V26.6C28 27 27.8667 27.3333 27.6 27.6C27.3333 27.8667 27 28 26.6 28Z"
                fill="white"
              />
            </svg>
          </Link>
        )}

        {showScrollTop ? (
          <button
            className="fixed bottom-3 right-3 bg-sky-600 text-white px-2 py-2 rounded-full shadow-lg z-50"
            onClick={scrollToTop}
          >
            <FaArrowUp />
          </button>
        ) : (
          <button
            className="fixed bottom-3 right-3 bg-sky-600 text-white px-2 py-2 rounded-full shadow-lg z-50"
            onClick={scrollToBottom}
          >
            <FaArrowDown />
          </button>
        )}

        {showBuyCar && <BuyersForm onClose={handleCloseBuyCar} />}
        {showCalculator && <EMICalculator onClose={handleCloseCalculator} />}
        {showCarSelection && (
          <CarSelection
            transactionType={transactionType}
            showCarSelection={showCarSelection}
            onClose={handleCloseCarSelection}
          />
        )}
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="ppf" element={<PPF />} />
        <Route path="ceramic" element={<Ceramic />} />
        <Route path="graphene" element={<Graphene />} />
        <Route path="contact" element={<ContactUs />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer id="footer" />
    </Router>
  );
}

export default App;
